import React from 'react';
import { Col, Container, Row } from 'reactstrap';
import { withTranslation } from 'react-i18next';
import PropTypes from 'prop-types';
import HorizontalForm from './components/outboundReports';
/*import Table from '../../Tables/DataTable/components/DataTable';*/
/*import VerticalForm from './components/masterForm';*/
/*import showResults from '../Show';*/

const outboundReports = ({ t }) => (
  <Container>
    <Row>
      <HorizontalForm />
    </Row>

   
  </Container>
);

outboundReports.propTypes = {
  t: PropTypes.func.isRequired,
};

export default withTranslation('common')(outboundReports);
